import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("tpt_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink text-cream flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
        <div className="font-serif text-4xl mb-1">Tan Putra Tama</div>
        <div className="text-[11px] uppercase tracking-[0.3em] text-clara-accent mb-10">Admin Console</div>

        <label className="block mb-6">
          <span className="text-[11px] uppercase tracking-widest text-cream/50 font-semibold">Email</span>
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required data-testid="admin-email"
            className="mt-2 w-full bg-transparent border-b border-cream/25 focus:border-clara-accent outline-none py-2.5 text-cream transition-colors" />
        </label>
        <label className="block mb-8">
          <span className="text-[11px] uppercase tracking-widest text-cream/50 font-semibold">Password</span>
          <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required data-testid="admin-password"
            className="mt-2 w-full bg-transparent border-b border-cream/25 focus:border-clara-accent outline-none py-2.5 text-cream transition-colors" />
        </label>

        {error && <p className="text-claris-accent text-sm mb-6" data-testid="admin-login-error">{error}</p>}

        <button type="submit" disabled={loading} data-testid="admin-login-btn"
          className="w-full inline-flex items-center justify-center gap-2 bg-clara text-white py-4 text-sm font-semibold uppercase tracking-widest hover:bg-[#8A362B] transition-colors disabled:opacity-60">
          <Lock size={15} /> {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
